import { post, get, baseURL } from "@/utils/request";

export const upadateUser = (params: any) => post(`/user/updateUser`, params);

export const upadateProfileImage = (params: any) => post(`/user/uploadProfileImage`, params);

export const setWithdrawPassword = (params: any) => post(`/user/withdrawPassword`, params);